import React, { useState, useRef, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Button from "./Button";
import { useNetwork } from "../../../context/NetworkContext";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import TotalCalculator from "@heartinz/checkout_billing_price_validator";
import { useShowAlert } from "../../../context/AlertContext";
import Messages from "../../../constants/Messages";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useContextApi } from "../../../context/ContextApi";
import { XIcon } from "../../../constants/Icons";

const QuickRecharge = ({ onClose }) => {
  const showAlert = useShowAlert();
  const { checkNetwork } = useNetwork();
  const [errorMessage, setErrorMessage] = useState({
    number: "",
    operator: "",
    amount: "",
    wallet: "",
  });
  const {useEscapeKey}=useContextApi();
  const [listWallet, setListWallet] = useState([]);
  const [isBtnLoading, setBtnLoading] = useState(false);

  const [saleData, setSaleData] = useState([]);
  const amountRef = useRef(null);
  const NumberRef = useRef(null);
  const operatorRef = useRef(null);
  const walletRef = useRef(null);
  const cashRef = useRef(null);
  const cardRef = useRef(null);
  const upiRef = useRef(null);
  const cashChangeRef = useRef(null);
  const upiChangeRef = useRef(null);
  const wavedoffchangeRef = useRef(null);
  const [selectedWalletId, setSelectedWalletId] = useState(null);
  const [amount, setAmount] = useState(0);
  const [number, setNumber] = useState(0);
  const [operator, setOperator] = useState("");
  const [wallet, setWallet] = useState("");
  const [totalPayable, setTotalPayable] = useState(0);
  const [cash, setCash] = useState(0);
  const [card, setCard] = useState(0);
  const [upi, setUpi] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [paylater, setPaylater] = useState(0);
  const [totalPaid, setTotalPaid] = useState(totalPayable);
  const [balance, setBalance] = useState(0);
  const [changeAmount, setChangeAmount] = useState(0);
  const [cashChange, setCashChange] = useState(0);
  const [upiChange, setUpiChange] = useState(0);
  const [wavedoffchange, setWavedOffChange] = useState(0);
  const [showChangePaymentUI, setShowChangePaymentUI] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const suggestionRef = useRef([]);
  const desRef = useRef();
  const [selectBalance,setSelectedBalance]=useState(null)

  const handleClose = () => {
    setErrorMessage({ number: "", operator: "", amount: "", wallet: "" });
    onClose();
  };
  useEscapeKey(handleClose);
  const fetchSuggestions = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/recharge/list-recharge-operator-suggestion`
      );
      setSuggestions(response.data.results);
      setShowSuggestions(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };
  useEffect(() => {
    var cashAmt = CurrencyConverter.toSubunit(cash || 0, "INR");
    var cardAmt = CurrencyConverter.toSubunit(card || 0, "INR");
    var upiAmt = CurrencyConverter.toSubunit(upi || 0, "INR");
    var disAmt = CurrencyConverter.toSubunit(discount || 0, "INR");
    var onlineAmt = CurrencyConverter.toSubunit(0, "INR");
    var paylaterAmt = CurrencyConverter.toSubunit(paylater || 0, "INR");
    var payObject = {
      cashamount: cashAmt,
      cardamount: cardAmt,
      onlineamount: onlineAmt,
      discountamount: disAmt,
      upiamount: upiAmt,
      paylateramount: paylaterAmt,
    };
    var totalVal = TotalCalculator.validateCheckout(totalPayable, payObject);
    const totalPaid = cashAmt + cardAmt + upiAmt;
    const newBalance = totalPayable - totalPaid;

    setTotalPaid(CurrencyConverter.toCurrency(totalPaid, "INR"));
    setBalance(newBalance);

    if (newBalance < 0) {
      setChangeAmount(Math.abs(newBalance));
    } else {
      setChangeAmount(0);
    }
  }, [cash, card, upi, discount, paylater, totalPayable]);

  const handleInputChange = (setValue) => (e) => {
    setShowChangePaymentUI(false);
    setCashChange(0);
    setUpiChange(0);
    setWavedOffChange(0);
    const value = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setValue(value);
    } else {
      setValue(0);
    }
  };

  const handleFocusFill = (mode) => {
    const grandTotal = Number(
      CurrencyConverter.toCurrency(totalPayable || 0, "INR")
    );

    const currentCash = Number(cash || 0);
    const currentCard = Number(card || 0);
    const currentUpi = Number(upi || 0);

    const totalAlreadyPaid = currentCash + currentCard + currentUpi;

    const remainingBalance = grandTotal - totalAlreadyPaid;

    if (remainingBalance <= 0) return;

    // Set untouched fields to 0 if they were empty
    if (!cash) setCash(0);
    if (!card) setCard(0);
    if (!upi) setUpi(0);

    // Add remainingBalance to the selected mode
    if (mode === "cash") {
      setCash(currentCash + remainingBalance);
      setTimeout(() => cashRef?.current?.select(), 0);
    } else if (mode === "card") {
      setCard(currentCard + remainingBalance);
      setTimeout(() => cardRef?.current?.select(), 0);
    } else if (mode === "upi") {
      setUpi(currentUpi + remainingBalance);
      setTimeout(() => upiRef?.current?.select(), 0);
    }
  };

  const handleWaveFocusFill = (mode) => {
    const changeamount = Number(
      CurrencyConverter.toCurrency(changeAmount || 0, "INR")
    );
    const currentCash = Number(cashChange || 0);
    const currentUpi = Number(upiChange || 0);
    const currentWavedoff = Number(wavedoffchange || 0);

    const totalAlreadyPaid = currentCash + currentUpi + currentWavedoff;

    const remainingBalance = changeamount - totalAlreadyPaid;
    if (remainingBalance <= 0) return;
    // Set other fields to 0 if they’re empty
    if (!cashChange) setCashChange(0);
    if (!upiChange) setUpiChange(0);
    if (!wavedoffchange) setWavedOffChange(0);

    if (mode === "cashChange") {
      setCashChange(currentCash + remainingBalance);
      setTimeout(() => cashChangeRef?.current?.select(), 0);
    } else if (mode === "upiChangeRef") {
      setUpiChange(currentUpi + remainingBalance);
      setTimeout(() => upiChangeRef?.current?.select(), 0);
    } else if (mode === "wavedoffchange") {
      setWavedOffChange(currentWavedoff + remainingBalance);
      setTimeout(() => wavedoffchangeRef?.current?.select(), 0);
    }
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (!validateForm(fieldName)) {
        return;
      }

      if (fieldName === "upi" && showChangePaymentUI) {
        cashChangeRef.current?.focus();
        cashChangeRef.current?.select();
        return;
      }
      if (isLast) {
        handleCashIn(e);
      } else if (nextRef?.current) {
        setTimeout(() => {
          if (fieldName === "operator") {
            nextRef.current.focus();
          } else {
            nextRef.current.focus();
            nextRef.current.select();
          }
        }, 10);
      }
    }
  };

  const handlePaylaterInputChange = (setValue, field) => (e) => {
    const changeamount = Number(
      CurrencyConverter.toCurrency(changeAmount || 0, "INR")
    );
    const value = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (!regex.test(value)) {
      setValue(0);
      return;
    }

    const newValue = parseFloat(value || 0);
    const currentValues = {
      cashchange: field === "cashchange" ? 0 : parseFloat(cashChange || 0),
      upichange: field === "upichange" ? 0 : parseFloat(upiChange || 0),
      wavedoffchange:
        field === "wavedoffchange" ? 0 : parseFloat(wavedoffchange || 0),
    };

    const totalChange =
      currentValues.cashchange +
      currentValues.upichange +
      currentValues.wavedoffchange +
      newValue;

    if (totalChange > changeamount) {
      showAlert("warning", Messages.ERROR.CHANGE_EXCEEDS_AMOUNT);
      return;
    }
    setValue(value);
  };
  const handleListRechargeWallet = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/recharge/list-recharge-wallet`
      );

      setListWallet(response.data.results);

      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const prepareSubmitData = () => {
    return {
      saleid: saleData._id || 0,
      saleitems: [
        {
          walletid: selectedWalletId,
          operator: operator,
          number: number,
          title: `Recharge - ${operator} - ${number}`,
          description: "Mobile Recharge",
          mrp: CurrencyConverter.toSubunit(amount || 0, "INR"),
          saleprice: CurrencyConverter.toSubunit(amount || 0, "INR"),
          soldprice: CurrencyConverter.toSubunit(amount || 0, "INR"),
          taxpercentage: 0,
          baseprice: CurrencyConverter.toSubunit(amount / 1.12, "INR"), // Adjust for tax
          isLock: "SALEPRICE",
          isStock: false,
          quantity: 1,
          imode: "RECHARGE",
        },
      ],
      cashamount: CurrencyConverter.toSubunit(cash || 0, "INR"),
      cardamount: CurrencyConverter.toSubunit(card || 0, "INR"),
      onlineamount: 0,
      upiamount: CurrencyConverter.toSubunit(upi || 0, "INR"),
      paylateramount: CurrencyConverter.toSubunit(paylater || 0, "INR"),
      waveoffamount: 0,
      cashchange: CurrencyConverter.toSubunit(cashChange || 0, "INR"),
      cardchange: 0,
      onlinechange: 0,
      upichange: CurrencyConverter.toSubunit(upiChange || 0, "INR"),
      paylaterchange: 0,
      waveoffchange: CurrencyConverter.toSubunit(wavedoffchange || 0, "INR"),
      changeamount: CurrencyConverter.toSubunit(changeAmount || 0, "INR"),
    };
  };
  const submitRecharge = async () => {
    const salemode = "BILL";
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      const selectedWalletName = wallet;
      const selectedWallet = listWallet.find(
        (w) => w?.walletname === selectedWalletName
      );
      if (
        CurrencyConverter.toCurrency(selectedWallet?.walletbalance || 0, "INR") <
        amount
      ) {
        showAlert(
          "error",
          `Insufficient balance in ${selectedWallet?.walletname} wallet`
        );
        return;
      }
      const createSaleResponse = await AxiosInstance.post(`module/sale`, {
        salemode,
      });
      const newSaleData = createSaleResponse.data.results;

      const submitData = {
        ...prepareSubmitData(),
        saleid: newSaleData._id || 0,
      };

      const response1 = await AxiosInstance.post(
        `module/sale/add-sale`,
        submitData
      );

      showAlert("success", Messages.SUCCESS.SALE_ADDED);
      onClose();
    } catch (error) {
      showAlert("error", "Failed to process recharge");
    } finally {
      setBtnLoading(false);
    }
  };

  const handleCashIn = async (event) => {
    event.preventDefault();
    if (!validateForm("all")) {
      return;
    }

    const totalPaidSubunit = CurrencyConverter.toSubunit(totalPaid, "INR");
    const cashChangeSubunit = CurrencyConverter.toSubunit(
      cashChange || 0,
      "INR"
    );
    const upiChangeSubunit = CurrencyConverter.toSubunit(upiChange || 0, "INR");
    const wavedoffSubunit = CurrencyConverter.toSubunit(
      wavedoffchange || 0,
      "INR"
    );

    const totalChangeGiven =
      cashChangeSubunit + upiChangeSubunit + wavedoffSubunit;
    const expectedChange = Math.max(0, totalPaidSubunit - totalPayable);

    if (totalPaidSubunit < totalPayable) {
      // Case 1: Paid less than payable
      cashRef.current?.focus();
      showAlert("warning", Messages.ERROR.INVALID_PAID_AMOUNT);
      return;
    } else if (totalPaidSubunit === totalPayable) {
      await submitRecharge();
    } else {
      // Case 3: Paid more than payable (change needed)
      if (!showChangePaymentUI) {
        // First time - open change UI
        setShowChangePaymentUI(true);
        cashChangeRef.current?.focus();
        cashChangeRef.current?.select();
        return;
      } else {
        // Change UI is open - validate change amounts
        if (totalChangeGiven !== expectedChange) {
          cashChangeRef.current?.focus();
          cashChangeRef.current?.select();
          showAlert("warning", Messages.ERROR.INVALID_CHANGE_AMOUNT);
          return;
        } else {
          await submitRecharge();
        }
      }
    }
  };

  const handleChange = (field, value) => {
    if (field === "operator") {
      setOperator(value.replace(/[0-9]/g, "")); 
  
      
      const filtered = suggestions.filter(
        (s) =>
          s?.operator &&
          s.operator.toLowerCase().includes(value.toLowerCase())
      );
  
      setFilteredSuggestions(filtered);
      setShowSuggestions(filtered.length > 0);
      setErrorMessage("");
    }
  };
  

  useEffect(() => {
    if (showChangePaymentUI) {
      cashChangeRef.current?.focus();
      cashChangeRef.current?.select();
    }
  }, [showChangePaymentUI]);
  const validateForm = (fieldName) => {
    const errors = {
      number: "",
      operator: "",
      wallet: "",
      amount: "",
    };

    let isValid = true;

    // Clear all errors first
    setErrorMessage(errors);

    const validateField = (field) => {
      switch (field) {
        case "number":
          if (!number || number.trim() === "") {
            errors.number = "Number is required.";
            NumberRef.current?.focus();
            isValid = false;
          }
          //  else if (!/^\d{10}$/.test(number)) {
          //   errors.number = "Number must be exactly 10 digits.";
          //   NumberRef.current?.focus();
          //   isValid = false;
          // }
          break;

        case "operator":
          if (!operator || operator.trim() === "") {
            errors.operator = "Operator is required.";
            operatorRef.current?.focus();
            isValid = false;
          } else if (/\d/.test(operator)) {
            errors.operator = "Operator should not contain numbers.";
            operatorRef.current?.focus();
            isValid = false;
          }
          break;

        case "wallet":
          if (!wallet || wallet.trim() === "") {
            errors.wallet = "Wallet is required.";
            walletRef.current?.focus();
            isValid = false;
          }
          break;

        case "amount":
          if (!amount) {
            errors.amount = "Amount cannot be empty.";
            amountRef.current?.focus();
            isValid = false;
          } else {
            const parsedValue = parseFloat(amount);
            if (isNaN(parsedValue)) {
              errors.amount = "Enter a valid numeric amount.";
              amountRef.current?.focus();
              isValid = false;
            } else if (parsedValue <= 0) {
              errors.amount = "Amount must be greater than 0.";
              amountRef.current?.focus();
              isValid = false;
            } else {
              const decimalPart = amount.split(".")[1];
              if (decimalPart && decimalPart.length !== 2) {
                errors.amount = "Amount must have exactly two decimal places.";
                amountRef.current?.focus();
                isValid = false;
              }
            }
          }
          break;

        default:
          break;
      }

      setErrorMessage((prev) => ({ ...prev, [field]: errors[field] }));
      return isValid;
    };

    if (fieldName === "all") {
      if (!validateField("number")) return false;
      if (!validateField("operator")) return false;
      if (!validateField("wallet")) return false;
      if (!validateField("amount")) return false;
      return true;
    } else {
      return validateField(fieldName);
    }
  };
  const handleWalletKeyDown = (e) => {
    if (e.key === "Enter" && wallet.trim()) {
      e.preventDefault();
      amountRef.current?.focus();
      amountRef.current?.select();
    }
  };
  const totalChange =
    parseFloat(cashChange || 0) +
    parseFloat(upiChange || 0) +
    parseFloat(wavedoffchange || 0);
  const changeamount = Number(
    CurrencyConverter.toCurrency(changeAmount || 0, "INR")
  );
  const isTotalChangeValid = totalChange === changeamount;

  // useEffect(() => {

  // }, []);
  useEffect(() => {
    NumberRef.current?.focus();
    NumberRef.current.select();
    fetchSuggestions();
    handleListRechargeWallet();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (operatorRef.current && !operatorRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (
      highlightedIndex >= 0 &&
      suggestionRef.current[highlightedIndex]
    ) {
      suggestionRef.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (showSuggestions) {
      setFilteredSuggestions(suggestions);
    }
  }, [suggestions, showSuggestions]);
  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show d-block"
        id="StoreModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Recharge Sale</h6>
              <button
                type="button"
                onClick={handleClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="card w-100 radius-10 mb-0 shadow-none">
                <div className="card-body p-0">
                  <form className="row g-3">
                    <div className="col-12 col-md-5">
                      <div className="card">
                        <div className="card-body">
                          <div className="rounded mb-0">
                            <div className="row">
                              <div className="col-md-12 pb-2">
                                <label
                                  htmlFor="description"
                                  className="form-label"
                                >
                                  Number{" "}
                                  <small className="text-danger">*</small>
                                </label>
                                <input
                                  type="text"
                                  name="number"
                                  autoComplete="off"
                                  className="form-control"
                                  ref={NumberRef}
                                  value={number}
                                  onClick={(e) => e.target.select()}
                                  onChange={(e) => {
                                    setNumber(
                                      e.target.value.replace(
                                        /[^a-zA-Z0-9]/g,
                                        ""
                                      )
                                    );
                                    setErrorMessage("");
                                  }}
                                  onKeyDown={(e) =>
                                    handleEnterKey(e, "number", operatorRef)
                                  }
                                  autoFocus
                                />
                                {errorMessage && (
                                  <div className="error-message invalid-feedback">
                                    {errorMessage.number}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-12 pb-2">
                                <label
                                  htmlFor="description"
                                  className="form-label"
                                >
                                  Operator{" "}
                                  <small className="text-danger">*</small>
                                </label>
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    name="operator"
                                    autoComplete="off"
                                    maxLength="5000"
                                    ref={operatorRef}
                                    className="form-control"
                                    value={operator}
                                    onClick={(e) => e.target.select()}
                                    onFocus={() => {
                                      // handleFieldInteraction("title")
                                      setShowSuggestions(true);
                                    }}
                                    onChange={(e) => 
                                      handleChange("operator", e.target.value)
                                    } 
                                    onKeyDown={(e) => {
                                      const key = e.key;
                                      if (e.key === "ArrowDown") {
                                        e.preventDefault();
                                        setHighlightedIndex((prev) =>
                                          Math.min(prev + 1, filteredSuggestions.length - 1)
                                        );
                                      } else if (e.key === "ArrowUp") {
                                        e.preventDefault();
                                        setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                                      } else if (e.key === "Tab" || e.key === "Enter") {
                                        if (highlightedIndex >= 0 && filteredSuggestions[highlightedIndex]) {
                                          e.preventDefault();
                                          const selected = filteredSuggestions[highlightedIndex];
                                          setOperator(selected.operator);
                                          setShowSuggestions(false);
                                          setHighlightedIndex(-1);
                                    
                                          setTimeout(() => {
                                            desRef.current?.focus();
                                          }, 10);
                                    
                                          // ✅ Call handleEnterKey to move focus properly
                                          handleEnterKey(e, "operator", walletRef);
                                        } else {
                                          // If no suggestion is highlighted, use the normal enter key handler
                                          handleEnterKey(e, "operator", walletRef);
                                        }
                                      } else {
                                        handleEnterKey(e, "operator", walletRef);
                                      }
                                    }}
                                    autoFocus
                                  />
                                  {showSuggestions &&
                                    filteredSuggestions.length > 0 && (
                                      <ul className="suggestions-list suggestions-list_Quick">
                                        {filteredSuggestions.map(
                                          (item, index) => (
                                            <li
                                              key={item._id}
                                              ref={(e) =>
                                                (suggestionRef.current[index] =
                                                  e)
                                              }
                                              className={`suggestion-item text-muted ${
                                                index === highlightedIndex
                                                  ? "highlighted"
                                                  : ""
                                              }`}
                                              onMouseDown={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setOperator(item.operator);
                                                setShowSuggestions(false);
                                                // setErrors("");
                                                setHighlightedIndex(-1);
                                                setTimeout(() => {
                                                  desRef.current?.focus();
                                                }, 10);
                                              }}
                                            >
                                              {item.operator}{" "}
                                              {/* <span className="badge bg-label-retro float-end">
                                  used {item.usageCount}
                                </span> */}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    )}

                                  {showSuggestions &&
                                    filteredSuggestions.length === 0 && (
                                      <ul className="suggestions-list">
                                        <li className="suggestion-item  text-muted">
                                          No suggestions found
                                        </li>
                                      </ul>
                                    )}
                                </div>
                                {errorMessage && (
                                  <div className="invalid-feedback">
                                    {errorMessage.operator}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-12 pb-2">
                                <label className="form-label">
                                  Wallet <span className="text-danger">* </span>
                                  <span className="badge  rounded-pill bg-label-plus">₹{CurrencyConverter.toCurrency(selectBalance || 0, "INR")}</span>
                                </label>
                                <select
                                  className="form-select"
                                  value={wallet}
                                  onChange={(e) => {
                                    const selectedWallet = listWallet.find(
                                      (w) => w.walletname === e.target.value
                                    );
                                    setSelectedBalance(selectedWallet?.walletbalance||0)
                                    setWallet(e.target.value);
                                    setSelectedWalletId(selectedWallet?._id);
                                    setErrorMessage("");
                                  }}
                                  onKeyDown={handleWalletKeyDown}
                                  ref={walletRef}
                                >
                                  <option>Select</option>
                                  {listWallet?.map((item) => (
                                    <option
                                      key={item?._id}
                                      value={item?.walletname}
                                    >
                                      {item?.walletname}
                                    </option>
                                  ))}
                                </select>
                                {errorMessage && (
                                  <div className="invalid-feedback">
                                    {errorMessage.wallet}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-12">
                                <label
                                  htmlFor="description"
                                  className="form-label"
                                >
                                  Amount{" "}
                                  <small className="text-danger">*</small>
                                </label>
                                <input
                                  type="text"
                                  name="amount"
                                  autoComplete="off"
                                  maxLength="5000"
                                  className="form-control"
                                  ref={amountRef}
                                  value={amount}
                                  onClick={(e) => e.target.select()}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                                      setAmount(value);
                                      const amountInSubunit = value
                                        ? CurrencyConverter.toSubunit(
                                            parseFloat(value),
                                            "INR"
                                          )
                                        : 0;
                                      setTotalPayable(amountInSubunit);
                                      setBalance(amountInSubunit);
                                      setErrorMessage("");
                                      setShowChangePaymentUI(false);
                                      setCashChange(0);
                                      setUpiChange(0);
                                      setWavedOffChange(0);
                                    }
                                  }}
                                  onKeyDown={(e) =>
                                    handleEnterKey(e, "amount", cashRef)
                                  }
                                  autoFocus
                                />
                                {errorMessage && (
                                  <div className="invalid-feedback">
                                    {errorMessage.amount}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-7">
                      <div className="card">
                        <div className="card-body">
                          <div className="rounded">
                            <div className="bg-light rounded p-2 text-center mb-3">
                              <h6 className="mb-0 fs-18 text-dark">
                                Total Payable :{" "}
                                <span>
                                  {" "}
                                  {CurrencyConverter.toCurrency(
                                    Math.abs(totalPayable),
                                    "INR"
                                  )}{" "}
                                </span>
                              </h6>
                            </div>
                            <div className="flex-grow-1 row justify-content-between align-items-center g-2">
                              <div className="col-6">
                                <h6 className="mb-0">Cash</h6>
                              </div>
                              <div className="col-6 text-end">
                                <input
                                  type="text"
                                  className="form-control"
                                  min="0"
                                  name="cash"
                                  autoComplete="off"
                                  value={cash}
                                  ref={cashRef}
                                  onClick={() => handleFocusFill("cash")}
                                  onKeyDown={(e) =>
                                    handleEnterKey(e, "cash", cardRef)
                                  }
                                  onFocus={(e) => e.target.select()}
                                  onChange={handleInputChange(setCash)}
                                />
                              </div>
                              <div className="col-6">
                                <h6 className="mb-0">Card</h6>
                              </div>
                              <div className="col-6 text-end">
                                <input
                                  type="text"
                                  name="card"
                                  ref={cardRef}
                                  autoComplete="off"
                                  className="form-control"
                                  min="0"
                                  value={card}
                                  onClick={() => handleFocusFill("card")}
                                  onKeyDown={(e) =>
                                    handleEnterKey(e, "card", upiRef)
                                  }
                                  onFocus={(e) => e.target.select()}
                                  onChange={handleInputChange(setCard)}
                                />
                              </div>

                              <div className="col-6">
                                <h6 className="mb-0">UPI</h6>
                              </div>
                              <div className="col-6 text-end">
                                <input
                                  type="text"
                                  name="upi"
                                  ref={upiRef}
                                  className="form-control"
                                  autoComplete="off"
                                  min="0"
                                  value={upi}
                                  onClick={() => handleFocusFill("upi")}
                                  onKeyDown={(e) =>
                                    handleEnterKey(e, "upi", null, true)
                                  }
                                  onFocus={(e) => e.target.select()}
                                  onChange={handleInputChange(setUpi)}
                                />
                              </div>

                              <div className="col-6">
                                <h6
                                  className={`mb-0 
                                      ${
                                        balance === 0
                                          ? "text-grey"
                                          : balance > 0
                                          ? "text-danger"
                                          : "text-success"
                                      }`}
                                >
                                  {balance === 0
                                    ? "Balance"
                                    : balance > 0
                                    ? "Balance"
                                    : "Change"}
                                </h6>
                              </div>
                              <div className="col-6 text-end">
                                <input
                                  type="text"
                                  className={`form-control ${
                                    balance === 0
                                      ? "bg-box-grey"
                                      : balance > 0
                                      ? "bg-box-danger"
                                      : "bg-box-success"
                                  }`}
                                  value={CurrencyConverter.toCurrency(
                                    balance,
                                    "INR"
                                  )}
                                  //  value={Math.max(0, totalPayable-(cash+card+upi))}
                                  disabled
                                />
                              </div>

                              <div className="col-6">
                                <h6 className="mb-0 bg-dark-text fw-500">
                                  Total Paid
                                </h6>
                              </div>
                              <div className="col-6 text-end">
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  value={totalPaid || 0}
                                  disabled
                                />
                              </div>
                            </div>
                            {showChangePaymentUI && (
                              <div className="card mt-3 mb-1">
                                <div className="card-body">
                                  <div className="rounded">
                                    <div className=" p-2 text-center  mb-0">
                                      <h6 className="mb-0 fs-14 text-dark pb-2">
                                        How Did You Pay Change?
                                      </h6>
                                      <div
                                        className={`rounded p-2 text-center mb-3 ${
                                          isTotalChangeValid
                                            ? "bg-light-success text-success"
                                            : "bg-light text-dark"
                                        }`}
                                      >
                                        <div className="mb-0 fs-15 fw-medium">
                                          Total Change :{" "}
                                          <span>
                                            {" "}
                                            {totalPaid -
                                              CurrencyConverter.toCurrency(
                                                Math.max(0, totalPayable),
                                                "INR"
                                              )}{" "}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex-grow-1 row justify-content-between align-items-center g-2">
                                      <div className="col-6">
                                        <h6 className="mb-0">Cash</h6>
                                      </div>
                                      <div className="col-6 text-end">
                                        <input
                                          type="text"
                                          name="cashChange"
                                          className="form-control"
                                          autoComplete="off"
                                          min="0"
                                          value={cashChange}
                                          ref={cashChangeRef}
                                          onClick={() =>
                                            handleWaveFocusFill("cashChange")
                                          }
                                          onFocus={(e) => {
                                            e.target.select();
                                          }}
                                          onKeyDown={(e) =>
                                            handleEnterKey(
                                              e,
                                              "cashChange",
                                              upiChangeRef
                                            )
                                          }
                                          onChange={handlePaylaterInputChange(
                                            setCashChange,
                                            "cashchange"
                                          )}
                                        />
                                      </div>
                                      <div className="col-6">
                                        <h6 className="mb-0">UPI</h6>
                                      </div>
                                      <div className="col-6 text-end">
                                        <input
                                          type="text"
                                          name="upiChangeRef"
                                          className="form-control"
                                          autoComplete="off"
                                          min="0"
                                          value={upiChange}
                                          ref={upiChangeRef}
                                          onClick={() =>
                                            handleWaveFocusFill("upiChangeRef")
                                          }
                                          onFocus={(e) => e.target.select()}
                                          onKeyDown={(e) =>
                                            handleEnterKey(
                                              e,
                                              null,
                                              wavedoffchangeRef
                                            )
                                          }
                                          onChange={handlePaylaterInputChange(
                                            setUpiChange,
                                            "upichange"
                                          )}
                                        />
                                      </div>

                                      <div className="col-6">
                                        <h6 className="mb-0 text-info">
                                          Waved Off
                                        </h6>
                                      </div>
                                      <div className="col-6 text-end">
                                        <input
                                          type="text"
                                          name="wavedoffchange"
                                          className="form-control"
                                          autoComplete="off"
                                          min="0"
                                          value={wavedoffchange}
                                          ref={wavedoffchangeRef}
                                          onClick={() =>
                                            handleWaveFocusFill(
                                              "wavedoffchange"
                                            )
                                          }
                                          onKeyDown={(e) =>
                                            handleEnterKey(
                                              e,
                                              "wavedoffchange",
                                              null,
                                              true
                                            )
                                          }
                                          onFocus={(e) => e.target.select()}
                                          onChange={handlePaylaterInputChange(
                                            setWavedOffChange,
                                            "wavedoffchange"
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className=" d-block pt-3">
                            <button
                              onClick={handleClose}
                              type="button"
                              data-bs-dismiss="modal"
                              className="btn btn-outline-secondary text-left mx-0"
                            >
                              <XIcon/> Cancel
                            </button>

                            {isBtnLoading ? (
                              <button
                                className="btn btn-primary pb-0 text-right"
                                disabled
                              >
                                <CircularProgress
                                  size={22}
                                  className="text-white"
                                />
                              </button>
                            ) : (
                              <Button
                                text="Save"
                                icon="bx bx-check"
                                bgColor="btn-primary"
                                textColor="text-white"
                                className="text-right mx-0"
                                onClick={handleCashIn}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickRecharge;
